import React from 'react';
import Button from '@material-ui/core/Button';
import 'styles/ScorecardQuestionnaireMetadata.styl';
import UserAvatar from 'components/pure/utils/UserAvatar';

export default class ScorecardQuestionnaireMetadata extends React.PureComponent {
  render() {
    const {model, scorecard, title, goToResults} = this.props;
    const scorecardHasAnswers = scorecard.results.count() > 0;
    return (
      <div className="scorecard-metadata scorecard-questionnaire-metadata">
        <div className="left">
          <div className="user-section">
            {model && <UserAvatar user={model.callDetails.caller} enableTooltip={true} />}
          </div>
        </div>
        <div className="center">
          <div className="title">
            <div className="title-container">
              <span className="card-title">{title}</span>
            </div>
          </div>
          <div className="notice-container">
            <span className="notice">
              Answer the following questions about the call to leave feedback
            </span>
          </div>
          {scorecardHasAnswers && (
            <div>
              <Button variant="outlined" className="ev-button" onClick={goToResults}>
                View Report
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
